import { render, staticRenderFns } from "./TrainingMy.vue?vue&type=template&id=2d84f6e0"
import script from "./TrainingMy.vue?vue&type=script&lang=js"
export * from "./TrainingMy.vue?vue&type=script&lang=js"
import style0 from "./TrainingMy.vue?vue&type=style&index=0&id=2d84f6e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports